import importExport from './import&export.vue'
import moment from 'moment'
export default {
  components: { importExport },
  methods: {
    importProduct() {
      this.$refs['importExport'].importProduct();
    },
    // 导出 --新接口
    onExport() {
      
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-api",
          paramMap: this.formData,
          reportName: "goodsSaleListExport",
        },
        columnDTOs: [],
      };
      let labels = this.columnData.map((v) => v.label);
      let props = this.columnData.map((v) => v.prop);
      props.forEach((prop, index) => {
        params.columnDTOs.push({
          columnName: labels[index],
          parentColumnName: null,
          fieldName: prop,
          fieldType: "string",
          columnFormat: null,
        });
      });
      // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter(
        (v) => v.columnName !== "图片"
      );
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
          loading.close()
        } else {
          this.$message.error(res.message);
        }
      });
    },
  }
}